import { render, staticRenderFns } from "./ParcelamentoCarne.vue?vue&type=template&id=08bc8e50"
import script from "./ParcelamentoCarne.vue?vue&type=script&lang=js"
export * from "./ParcelamentoCarne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports